<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- 端口列表 -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnPort"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">端口</p>
                <table
                  id="portList"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <!-- <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('CARPORT_NAME',$event)"
                      >车棚名称</th>-->
                      <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('ELECTRICITY_METER_NAME',$event)"
                      >电表名称</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:100px;"
                        @click="getList('ELECTRICITY_METER_SN',$event)"
                      >电表串号</th>
                      <th
                        class="text-left sorting"
                        style="min-width:150px;"
                        @click="getList('CHARGING_PILE_NAME',$event)"
                      >充电桩编号</th>
                      <th
                        class="text-left sorting"
                        style="min-width:150px;"
                        @click="getList('CHARGING_PILE_SN',$event)"
                      >设备号</th>
                      <!-- <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('HARDWARE_VERSION ',$event)"
                      >固件号</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('CHARGING_PILE_MODEL ',$event)"
                      >型号</th>-->
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('PORT_ID',$event)"
                      >端口号</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:126px;"
                        @click="getList('ID',$event)"
                      >端口UP值(元)</th>
                      <!-- <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:125px;"
                        @click="getList('ID',$event)"
                      >累计充电次数</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:150px;"
                        @click="getList('ID',$event)"
                      >累计充电金额(元)</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:165px;"
                        @click="getList('ID',$event)"
                      >累计充电时长(小时)</th>-->

                      <th
                        class="text-center sorting"
                        style="width: 100px;min-width: 100px;"
                        @click="getList('ID',$event)"
                      >安装状态</th>
                      <th
                        class="text-center sorting"
                        style="width: 100px;min-width: 100px;"
                        @click="getList('ID',$event)"
                      >在线状态</th>
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 100px;min-width:100px;"
                        @click="getList('ID',$event)"
                      >实时状态</th>
                      <th
                        class="text-center no-print"
                        style="width: 100px; min-width:100px"
                        v-if=" stateBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="meters.length">
                    <tr v-for="(item, i) in meters" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <!-- <td class="text-left d-md-table-cell">{{ item.CARPORT_NAME }}</td> -->
                      <td class="text-left">{{ item.ELECTRICITY_METER_NAME }}</td>
                      <td class="text-left">{{ item.ELECTRICITY_METER_SN }}</td>
                      <td class="text-left">{{ item.CHARGING_PILE_NAME }}</td>
                      <td class="text-left">{{ item.CHARGING_PILE_SN }}</td>
                      <!-- <td class="text-left">{{ item.HARDWARE_VERSION }}</td>
                      <td class="text-left">{{ item.CHARGING_PILE_MODEL }}</td>-->
                      <td class="text-left">{{item.PORT_ID}}</td>
                      <td class="text-left">{{changeTwoDecimal(item.ARPU_MONEY) }}</td>
                      <!-- <td class="text-left d-md-table-cell">{{ item.ORDER_NUM }}</td>
                      <td class="text-left">{{ changeTwoDecimal(item.TOTAL_MONEY) }}</td>
                      <td class="text-left">{{item.TOTAL_MINUTE }}</td>-->

                      <td class="text-center">
                        <!-- <span
                          v-show="item.PORT_STATE == '1'||item.PORT_STATE == '2'"
                          class="far fa-check-circle text-success"
                        ></span>
                        <span
                          v-show="item.PORT_STATE == '0'"
                          class="far fa-times-circle text-danger"
                        ></span>-->
                        <span
                          class="badge-pill"
                          :class="{'text-success':item.PORT_STATE != '0','text-secondary':item.PORT_STATE == '0'}"
                        >
                          <i
                            :class="{'fa fa-check-circle': item.PORT_STATE != 0 ,'fa fa-times': item.PORT_STATE == 0}"
                          ></i>
                        </span>
                      </td>
                      <td class="text-center d-xl-table-cell deviceStatus">
                        <span
                          class="badge badge-pill"
                          :class="{'text-success':item.DEVICE_STATE == '1','text-secondary':item.DEVICE_STATE != '1', 'wifiDis': item.DEVICE_STATE != '1'}"
                        >
                          <i class="fa fa-wifi"></i>
                        </span>
                        <span class="wifi-error" v-show="item.DEVICE_STATE != '1'">
                          <i class="fa fa-exclamation-circle"></i>
                        </span>
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <!-- DEVICE_STATE 设备状态：1在线2离线
                        PORT_STATE 端口状态：0:未安装 1:空闲 2：使用-->
                        <span
                          class="badge badge-pill"
                          :class="{'badge-secondary': item.PORT_STATE == '2', 
                                 'badge-success': item.PORT_STATE == '1'|| item.PORT_STATE == '0'}"
                        >{{ item.PORT_STATE=="1" || item.PORT_STATE == '0'?"空闲":item.PORT_STATE=="2" ?"占用": ""}}</span>
                      </td>
                      <td class="text-center no-print" v-if=" stateBtn">
                        <div class="btn-group">
                          <button
                            v-if="stateBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="重置"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="createSet(item)"
                          >
                            <i class="fa fa-redo-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="13">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="meters && meters.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      meters: [],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false,
      listUrl: "",
      form: {
        portId: "",
        portState: "",
        chargingPileSn: ""
      },
      stateBtn: Util.isHavePerm("chargePile/updateChargePilePortState")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    scopeParams() {
      return this.$store.state.scopeParams;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.scope) {
      this.$store.commit("setParam", {
        scopeParams: this.$route.params
      });
    } else if (this.$route.params.id) {
      this.$store.commit("setParam", {
        scopeParams: {
          scope: "",
          target: ""
        }
      });
    }
    if (this.$route.name == "allDevice") {
      this.listUrl = `${Util.searchURL}/FlatComplex/ListByAllPort`;
    }
    if (this.$route.name == "carportAllDevice") {
      this.listUrl = `${Util.searchURL}/Carport/ListByAllPort`;
    }
    this.getList();
    this.copy();
    // setTimeout(() => {
    //   $('#portList').DataTable({
    //     scrollX: true,
    //     searching: false,//搜索
    //     info: false,
    //     scrollCollapse: true,
    //     paging: false,
    //     fixedColumns: {
    //         leftColumns: 0,
    //         rightColumns: 1
    //     },
    //     drawCallback: function(){
    //         //重绘的回调执行
    //     }
    // } );
    // }, 1000);
  },
  methods: {
    createSet(val) {
      this.form = {
        portId: val.PORT_ID,
        portState: 1,
        chargingPileSn: val.CHARGING_PILE_SN
      };
      swal("确定重置？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.switchChange();
            break;
        }
      });
    },
    switchChange() {
      this.$http
        .post(
          `${Util.operateURL}/chargePile/updateChargePilePortState`,
          this.form
        )
        .then(res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        });
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }
      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${this.listUrl}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.meters = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${this.listUrl}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      if (
        this.$route.name == "allDevice" ||
        this.$route.name == "carportAllDevice"
      ) {
        copyStr = document.getElementsByTagName("section")[3].innerText;
      }
      var btn = document.getElementById("copybtnPort");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showStatus(str) {
      switch (str) {
        case "0":
          return "停用";
        case "1":
          return "在线";
        case "2":
          return "离线";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    inputChangeFourDecimal(val) {
      return Util.inputChangeFourDecimal(val);
    },
    formatTimeG(val) {
      return Util.formatTimeG(val);
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>